import { inject, Injectable, signal } from '@angular/core';
import {
  ChangePasswordForm,
  CreateUserPassword,
  DeactivateUserForm,
  ForgotPassword,
  LoginFromData,
  ResetPassword,
  SignupForm,
  SocialAuthProvidersFrom,
  UserDetails,
  VerifyEmailOTP,
} from 'src/app/shared/models';
import { Store } from '@ngrx/store';
import {
  changePassword,
  createUserPassword,
  deactivateUser,
  deleteUserProfileImage,
  forgotPassword,
  getUserDetails,
  login,
  resetPassword,
  setLoadingState,
  signOutConfirmed,
  signUp,
  updateUserProfileDetails,
  updateUserProfileImage,
  verifyEmailOtp,
} from 'src/app/root-store/user-store/actions';
import { BehaviorSubject } from 'rxjs';
import {
  selectUserDetails,
  selectUserIsDeactivating,
  selectUserIsLoading,
} from 'src/app/root-store/user-store/selectors';
import { toObservable } from '@angular/core/rxjs-interop';
import { AuthServiceAris } from './auth.service';
import { BrowserStorageService } from 'src/app/shared/utils/browser-storage.service';
@Injectable({
  providedIn: 'root',
})
export class AuthFacadeService {
  auth = inject(AuthServiceAris);
  storage = inject(BrowserStorageService);
  store = inject(Store);
  isLoading$ = this.store.select(selectUserIsLoading);
  isDeactivating$ = this.store.select(selectUserIsDeactivating);
  userDetails$ = this.store.select(selectUserDetails);
  pendingEmail$ = new BehaviorSubject<string>(null);

  protected userBreadCrumbItems = signal<any[]>([]);
  userBreadCrumb$ = toObservable(this.userBreadCrumbItems);
  setBreadCrumbValue(value: any[]) {
    this.userBreadCrumbItems.set(value);
  }
  constructor() {}

  signUp(data: SignupForm) {
    this.store.dispatch(signUp({ data }));
  }

  login(data: LoginFromData) {
    this.store.dispatch(login({ payload: data }));
  }
  signOut() {
    this.storage.clear();
    this.store.dispatch(signOutConfirmed());
  }
  getUserDetails() {
    this.store.dispatch(getUserDetails());
  }
  updateUserDetails(data: UserDetails) {
    this.store.dispatch(updateUserProfileDetails({ payload: data }));
  }
  updateUserProfileImage(file: File) {
    this.store.dispatch(updateUserProfileImage({ payload: file }));
  }
  deleteProfileImage() {
    this.store.dispatch(deleteUserProfileImage());
  }

  deactivateUser(data: DeactivateUserForm) {
    this.store.dispatch(deactivateUser({ payload: data }));
  }

  verifyOtp(data: VerifyEmailOTP) {
    this.store.dispatch(verifyEmailOtp({ payload: data }));
  }

  createUserPassword(data: CreateUserPassword) {
    this.store.dispatch(createUserPassword({ data }));
  }

  changePassword(data: ChangePasswordForm) {
    this.store.dispatch(changePassword({ data }));
  }
  forgotPassword(data: ForgotPassword) {
    this.store.dispatch(forgotPassword({ data }));
  }
  resetUserPassword(data: ResetPassword) {
    this.store.dispatch(resetPassword({ payload: data }));
  }

  socialAuthentication(data: SocialAuthProvidersFrom) {
    return this.auth.socialAuthentication(data);
  }

  setLoadingState(isLoading: boolean) {
    this.store.dispatch(setLoadingState({ isLoading }));
  }
}
